// src/pages/settings/SettingsUI.jsx
import React from 'react';

export const GREEN = '#2e9f86';
export const asArray = (d) =>
  Array.isArray(d) ? d
  : Array.isArray(d?.data) ? d.data
  : Array.isArray(d?.items) ? d.items
  : [];

const INP_CSS = ".inp{width:100%;border:1px solid #d1d5db;border-radius:.5rem;padding:.5rem .75rem;margin-top:.25rem}";

export function Header({ title, onAdd, addLabel }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
      {onAdd ? (
        <button onClick={onAdd} className="px-4 py-2 rounded text-white font-bold text-sm" style={{ backgroundColor: GREEN }}>
          + {addLabel || 'Add'}
        </button>
      ) : null}
    </div>
  );
}

export function Modal({ title, children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-2xl w-[440px] max-w-[92vw] p-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-lg">{title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-xl">x</button>
        </div>
        {children}
      </div>
      <style>{INP_CSS}</style>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="text-sm text-gray-600">{label}</label>
      {children}
    </div>
  );
}

export function Actions({ busy, disabled, onClose, onSave, cancelLabel, saveLabel, savingLabel }) {
  return (
    <div className="flex gap-2 pt-2">
      <button onClick={onClose} className="flex-1 py-2 rounded bg-gray-100 hover:bg-gray-200 font-semibold">
        {cancelLabel || 'Cancel'}
      </button>
      <button onClick={onSave} disabled={busy || disabled} className="flex-1 py-2 rounded text-white font-bold disabled:opacity-40" style={{ backgroundColor: GREEN }}>
        {busy ? (savingLabel || 'Saving...') : (saveLabel || 'Save')}
      </button>
    </div>
  );
}